var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLikeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 122.88 122.88",
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "like-button") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("path", {
    id: "svg_5",
    fillRule: "evenodd",
    fill: "#1a202c",
    d: "m61.44,0a61.44,61.44 0 1 1 -61.44,61.44a61.44,61.44 0 0 1 61.44,-61.44z",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_6",
    fill: "#fff",
    fillRule: "evenodd",
    d: "m32.5,53.39l10.56,0a2.18,2.18 0 0 1 2.17,2.18l0,28.95a2.19,2.19 0 0 1 -2.17,2.18l-10.56,0a2.19,2.19 0 0 1 -2.18,-2.18l0,-28.95a2.19,2.19 0 0 1 2.18,-2.18zm27.7,-21.71c1.14,-5.82 10.66,-0.46 11.29,8.91a40.41,40.41 0 0 1 -0.81,9.93l13.61,0c5.65,0.23 10.59,4.28 7.1,10.93c0.8,2.9 0.92,6.3 -1.24,7.65c0.27,4.57 -1,7.41 -3.37,9.65a11.42,11.42 0 0 1 -1.78,5.88c-1.83,2.58 -3.31,2 -6.19,2l-23,0c-3.64,0 -5.62,-1 -8,-4l0,-25.63c6.91,-1.83 10.55,-11.2 12.39,-17.35l0,-8l0,0.03z",
    className: "cls-999"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeIcon);
export default __webpack_public_path__ + "static/media/like-icon.0922e9d021e925997c8c43a4c046fd7c.svg";
export { ForwardRef as ReactComponent };